import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export const ProtectedRoute = ({ children, requiredRoute = null, requireCMS = false }) => {
  const { currentUser, permissions } = useAuth();
  const location = useLocation();

  if (!currentUser) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" replace />;
  }

  // Client mode: restrict access to their assigned portal and insights only
  if (permissions?.clientMode && permissions?.clientCompanyId) {
    const portalPath = `/portal/${permissions.clientCompanyId}`;
    const isOnPortal = location.pathname.startsWith(portalPath);
    const isOnInsights = location.pathname === '/insights';
    const isOnHome = location.pathname === '/';

    if (!isOnPortal && !isOnInsights && !isOnHome) {
      return <Navigate to={portalPath} replace />;
    }
    return children;
  }

  // Check route-specific permissions
  if (requiredRoute && permissions) {
    // Must have a non-empty routes array containing the required route
    const hasAccess = permissions.routes && permissions.routes.length > 0 && permissions.routes.includes(requiredRoute);

    if (!hasAccess) {
      // Redirect to home if user doesn't have access to this route
      return <Navigate to="/" replace />;
    }
  }

  // Check CMS-specific permissions
  if (requireCMS && permissions) {
    if (!permissions.CMS_access) {
      // Redirect to home if user doesn't have CMS access
      return <Navigate to="/" replace />;
    }
  }

  return children;
};
